// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useMantineTheme, useMantineColorScheme } from '@mantine/core';
import { Anchor, Badge, Box, Button, Card, Center, Checkbox, Container, PasswordInput, Stack, Text, TextInput, Title } from '@/components/ui';
import { IconMail, IconLock, IconArrowLeft, IconSquareRounded } from '@tabler/icons-react';
import { FadeIn } from '@/components/animations';
import { SocialLoginButtons } from '../components';

export default function ForgotCenteredCard() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const theme = useMantineTheme();
  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === 'dark';

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login:', { email, password, rememberMe });
  };

  return (
    <Box
      style={{
        minHeight: '100vh',
        backgroundColor: isDark ? theme.colors.dark[8] : theme.colors.gray[0],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      <Container size="xs" w="100%">
        <FadeIn>
          <Card
            padding="xl"
            radius="lg"
            style={{
              boxShadow: isDark
                ? '0 20px 60px rgba(0, 0, 0, 0.5)'
                : '0 20px 60px rgba(0, 0, 0, 0.15)',
            }}
          >
            <Stack gap="lg">
              <Button
                component={Link}
                to="/demo/auth-pages/forgot-password"
                variant="subtle"
                size="xs"
                leftSection={<IconArrowLeft size={14} />}
                w="fit-content"
              >
                Back to variants
              </Button>

              <Stack gap="xs" align="center">
                <Badge
                  leftSection={<IconSquareRounded size={12} />}
                  variant="gradient"
                  gradient={{ from: 'indigo', to: 'cyan' }}
                  size="lg"
                >
                  Centered Card
                </Badge>
                <Title order={2} ta="center" mt="md">
                  Forgot password?
                </Title>
                <Text c="dimmed" size="sm" ta="center">
                  Enter your email to reset your password
                </Text>
              </Stack>

              <form onSubmit={handleSubmit}>
                <Stack gap="md">
                  <TextInput
                    label="Email"
                    placeholder="you@example.com"
                    leftSection={<IconMail size={16} />}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />

                  <PasswordInput
                    label="Password"
                    placeholder="Your password"
                    leftSection={<IconLock size={16} />}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />

                  <Checkbox
                    label="Remember me"
                    checked={rememberMe}
                    onChange={(e) => setRememberMe(e.currentTarget.checked)}
                  />

                  <Button type="submit" fullWidth size="md" gradient={{ from: 'indigo', to: 'cyan' }} variant="gradient">
                    Sign in
                  </Button>
                </Stack>
              </form>

              <Stack gap="md">
                <Text ta="center" size="sm" c="dimmed">
                  Or continue with
                </Text>
                <SocialLoginButtons providers={['google', 'github']} layout="row" />
              </Stack>

              <Stack gap="xs" align="center">
                <Anchor component={Link} to="/demo/auth-pages/forgot-password/centered-card" size="sm">
                  Forgot your password?
                </Anchor>
                <Text size="sm" c="dimmed">
                  Don't have an account?{' '}
                  <Anchor component={Link} to="/demo/auth-pages/register/centered-card" fw={500}>
                    Sign up
                  </Anchor>
                </Text>
              </Stack>
            </Stack>
          </Card>
        </FadeIn>
      </Container>
    </Box>
  );
}
